export default {
  tabs: {
    graphics: 'Gráficos',
    dashboard: 'Dashboard',
    board: 'Board',
    calendar: 'Calendário',
    datagrid: 'Datagrid',
    forms: 'Formulários',
    elements: 'Elementos',
  },
  board: {
    searchPlaceholder: 'Pesquisar cards...',
  },
  forms: {
    tagbox: {
      title: 'Tagbox',
      label: 'Tags coloridas',
    },
    comboMultiple: {
      title: 'Combo múltiplo',
      label: 'Selecione várias tags',
      placeholder: 'Selecione uma ou mais tags',
      tags: {
        test: 'Teste',
        priority: 'Prioridade',
        review: 'Revisar',
        done: 'Concluído',
      },
    },
  },
  graphics: {
    sections: {
      summary: 'Indicadores resumidos',
      quick: 'Gráficos rápidos',
      bullets: 'Bullets agrupados',
      audio: 'Medição de áudio',
      audioSources: 'Fontes ao vivo dos medidores de áudio',
      trends: 'Tendências e evolução',
      comparisons: 'Comparações',
      multidimensional: 'Análise multidimensional',
      composition: 'Composição e distribuição',
      advanced: 'Funil, pirâmide, dispersão, intensidade e proporção',
    },
    audio: {
      physicalSource: 'Entrada física',
      useInput: 'Usar microfone / interface',
      stop: 'Parar',
      stopped: 'Parado',
      tabSource: 'Aba / YouTube',
      captureTab: 'Capturar aba com áudio',
    },
  },
  dashboard: {
    sections: {
      executive: 'Visão executiva',
      operations: 'Saúde operacional',
      commercial: 'Funil comercial',
      analytics: 'Tendências e composição',
    },
    labels: {
      mrr: 'Receita recorrente',
      activeCustomers: 'Clientes ativos',
      pipeline: 'Pipeline comercial',
      pipelineValue: 'Pipeline',
      forecastValue: 'Forecast',
      customerGrowth: 'Crescimento da base',
      currentMonth: 'Mês atual',
      quarter: 'Trimestre',
      change: 'Variação',
      previous: 'Anterior',
      sla: 'SLA operacional',
      current: 'Atual',
      cycleTime: 'Cycle Time',
      deliveryHealth: 'Saúde de delivery',
      availability: 'Disponibilidade',
      incidents: 'Incidentes',
      commercialFunnel: 'Conversão comercial',
      generated: 'Gerados',
      qualified: 'Qualificados',
      won: 'Ganhos',
      commercialEfficiency: 'Eficiência comercial',
      conversionRate: 'Conversão',
      averageTicket: 'Ticket médio',
      revenueTrend: 'Receita e expansão',
      revenueForecast: 'Receita x forecast',
      revenueGoal: 'Meta de receita',
      pipelineGoal: 'Meta de pipeline',
      commercialResult: 'Resultado comercial',
      ytd: 'Acumulado no ano',
      channelMix: 'Origem dos leads',
    },
    units: {
      currencyThousands: 'R$ mil',
      percent: '%',
      hours: 'h',
      customers: 'clientes',
      leads: 'leads',
      incidents: 'incidentes',
    },
    series: {
      revenue: 'Receita',
      expansion: 'Expansão',
      forecast: 'Forecast',
      pipeline: 'Pipeline',
      leads: 'Leads',
    },
    channels: {
      organic: 'Orgânico',
      outbound: 'Outbound',
      partners: 'Parceiros',
      events: 'Eventos',
    },
  },
};
